


const getAlgorithmVariations = (commonCanopies, commonVariaton) => {

	return {
		'0820': {
			...commonVariaton,
			size: {
				width: 0.0907,
				height: 0.397,
				depth: 0.0907
			},
			paddingTop: -0.35,
			familyName: 'algorithm',
			related: ['0820'],
			canopy: {
				...commonCanopies,
				"10": {
					...commonCanopies['10'],
					source: '/models/canopy_algorithm.glb',
					size: {
						width: 0.195,
						depth: 0.195,
						height: 0.135
					},
				}
			},
			light: {
				type: 'point',
				power: 320
			}
		}
	}
}

export default getAlgorithmVariations